module.exports = __webpack_public_path__ + "assets/img/money-bg-icon2.9c546654.png";